import Checkmark from './checkmark.svg';

export default Checkmark;



// WEBPACK FOOTER //
// ./src/components/Checkmark/index.js